import qs from 'qs';
import axios from 'axios'
import config from '../config'

// console.log(localStorage.getItem('token'))
const api = axios.create({
	baseURL: config.baseUrlAuction,
	withCredentials: true,
	headers: {
		post: {
			'Content-Type': 'application/x-www-form-urlencoded',
			// 'Authorization':localStorage.getItem('token')
		}
	}
});

const fetch = (path, data) => {
	return new Promise((resolve, reject) => {
		return api({
			method: 'POST',
			data: qs.stringify(data),
			url: path,
			timeout: 20000
		}).then(
			({ status,data }) => {
				if (status === 200 && data) {
					// console.log(data.code)
					switch (data.code) {
						case -1:
							resolve(data);
							break;
						case 0:
							resolve(data);
							break;
						case -101:
							resolve(data);
							localStorage.setItem('isLogin', '0');
							localStorage.removeItem('token');
							localStorage.removeItem('userInfo');
							break;
						default:
							reject(data);
							break;
					}
				} else {
					reject(data);
				}
			},
			reject
		);
	});
};

// 轮播广告
export function banner({is_type}) {
	return fetch('/banner', {is_type})
}

// 资产分类
export function category({is_type}) {
	return fetch('/category', {is_type});
}

// 资产列表
export function goods({page, limit, category_id, is_style, search_key, status}) {
	return fetch('/goods', {page, limit, category_id, is_style, search_key, status});
}

// 专家团队
export function person({page, limit}) {
	return fetch('/person', {page, limit});
}

// 律师调解
export function lawyer({page, limit}) {
	return fetch('/lawyer', {page, limit});
}

// 帮助中心
export function helper({page, limit}) {
	return fetch('/helper', {page, limit});
}

// 交易服务
export function services({page, limit}) {
	return fetch('/services', {page, limit});
}

// 资产详情
export function goodsDetail({id}) {
	return fetch('/goods_detail', {id});
}

// 竞价记录
export function record({page, limit, goods_id}) {
	return fetch('/record', {page, limit, goods_id});
}

// 竞拍流程
export function flows({category_id}) {
	return fetch('/flows', {category_id})
}

// 基础信息
export function meInfo({token}) {
	return fetch('/me_info', {token});
}


// 出价
export function commitRecord({goods_id, price, token}) {
	return fetch('/commit_record', {goods_id, price, token});
}

// 我的拍卖
export function meRecord({page, limit, token}) {
	return fetch('/me_record', {page, limit, token});
}

// 绑定资产
export function meBinds({page, limit, token}) {
	return fetch('/me_binds', {page, limit, token});
}

// 关于我们
export function about() {
	return fetch('/about');
}

// 拍卖权限
export function checkPaimai({goods_id, token}) {
	return fetch('/check_paimai', {goods_id, token});
}

// 浏览上报
export function viewReport({id}) {
	return fetch('/view_report', {id})
}

// 租赁管理
export function lease(data) {
	return fetch('/lease', data);
}

// 出价信息
export function record_info({goods_id, token}) {
	return fetch('/record_info', {goods_id, token});
}

// 文章详情
export function articles_detail({id}) {
	return fetch('/articles_detail', {id});
}

// 副广告
export function banner_sub({is_type}) {
	return fetch('/banner_sub', {is_type});
}

// 订阅变更
export function notice_chg({goods_id, token}) {
	return fetch('/notice_chg', {goods_id, token});
}
// 订阅检测
export function check_notice({goods_id, token}) {
	return fetch('/check_notice', {goods_id, token});
}

// 我的提醒
export function me_notice({page,limit,token}) {
	return fetch('/me_notice', {page,limit,token});
}

// 用途
export function getStyleGoods() {
	return fetch('/is_style_goods');
}
// // 修改手机号
// export function editPhone(data) {
// 	return fetch('index/usersapi/editPhone', data);
// }
//
// // 获取修改密码验证码
// export function getEditPasswordCode(data) {
// 	return fetch('index/usersapi/getEditPasswordCode', data);
// }

